import { render, staticRenderFns } from "./BannerTipComponent.vue?vue&type=template&id=0c2741bc&scoped=true"
import script from "./BannerTipComponent.vue?vue&type=script&lang=js"
export * from "./BannerTipComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerTipComponent.vue?vue&type=style&index=0&id=0c2741bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2741bc",
  null
  
)

export default component.exports